import { render, staticRenderFns } from "./UiHeaderBox.vue?vue&type=template&id=1704a4c4&scoped=true"
import script from "./UiHeaderBox.vue?vue&type=script&lang=js"
export * from "./UiHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./UiHeaderBox.vue?vue&type=style&index=0&id=1704a4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704a4c4",
  null
  
)

export default component.exports